import React from 'react'
import { connect } from 'react-redux'

const DefaultView = (props) => {
  return (
    <div>
      <p>{props.notification}</p>
      <div className='info'>Give dates as inputs</div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    notification: state.notification
  }
}

const Default = connect(mapStateToProps)(DefaultView)
export default Default